import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import AmountField from 'app/main/components/AmountField';
import AmountAndPercentageField from 'app/main/components/AmountAndPercentageField';
import { formatMoney } from 'app/main/utils/numberUtils';
import clsx from 'clsx';

function CollectedFees(props) {
  const { form, classes, collectedTotalAmount, handleChange } = props;

  return (
    <>
      <div className="flex items-center my-20">
        <Typography className={classes.feesTitle} component="h2">
          <b>Collected fees &#38; CD - </b>
        </Typography>
        <Typography component="h2" className="ml-4">
          <span>
            <b>Total: </b>
          </span>
          {`$ ${formatMoney(collectedTotalAmount, 2)}`}
        </Typography>
      </div>
      <AmountField
        autoFocus
        label="Origination Fee"
        id="collectedFees.originationFee"
        className={classes.field}
        value={form.collectedFees.originationFee}
        onChange={handleChange}
      />
      <AmountAndPercentageField
        id="collectedFees.discount"
        label="Discount"
        className={`${classes.field} ${classes.fieldPercentage}`}
        total={form.loan.loanAmount}
        value={form.collectedFees.discount}
        onChange={handleChange}
      />
      <AmountAndPercentageField
        id="collectedFees.yieldSpread"
        label="Yield Spread"
        className={`${classes.field} ${classes.fieldPercentage}`}
        total={form.loan.loanAmount}
        value={form.collectedFees.yieldSpread}
        onChange={handleChange}
      />
      <AmountField
        label="Appraisal"
        id="collectedFees.appraisal"
        className={classes.field}
        value={form.collectedFees.appraisal}
        onChange={handleChange}
      />
      <AmountField
        label="Credit Report"
        id="collectedFees.creditReport"
        className={classes.field}
        value={form.collectedFees.creditReport}
        onChange={handleChange}
      />
      <AmountField
        label="Processing Fee"
        id="collectedFees.processingFee"
        className={classes.field}
        value={form.collectedFees.processingFee}
        onChange={handleChange}
      />
      <AmountField
        label="Underwriting Fee"
        id="collectedFees.underwritingFee"
        className={classes.field}
        value={form.collectedFees.underwritingFee}
        onChange={handleChange}
      />
      <AmountField
        label="Broker Fee"
        id="collectedFees.brokerFee"
        className={classes.field}
        value={form.collectedFees.brokerFee}
        onChange={handleChange}
      />
      <AmountField
        label="Commission Rate"
        id="collectedFees.commissionRate"
        className={classes.field}
        value={form.collectedFees.commissionRate}
        onChange={handleChange}
      />
      <TextField
        label="Checks"
        id="collectedFees.checks"
        name="collectedFees.checks"
        className={clsx(classes.field, 'mt-8 mb-16')}
        value={form.collectedFees.checks}
        onChange={handleChange}
        variant="outlined"
      />
      <AmountField
        label="Broker Credit"
        id="collectedFees.brokerCredit"
        className={classes.field}
        value={form.collectedFees.brokerCredit}
        onChange={handleChange}
      />
      <AmountField
        label="NBR Bonus"
        id="collectedFees.nbrBonus"
        className={classes.field}
        value={form.collectedFees.nbrBonus}
        onChange={handleChange}
      />
    </>
  );
}

export default CollectedFees;
